import React from 'react';

import PropTypes from 'prop-types';
import Button from '@tds/core-button';

import { useLocalizedStringsContext } from '../../../../../context/LocalizedStringsContext';

const ActionButtons = ({ onApplyFilters }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { buttonApply, buttonReset }
  } = localizedStrings;
  return (
    <div
      style={{
        margin: '1rem 2rem',
        display: 'flex',
        justifyContent: 'start',
        gridArea: 'f-actionButtons'
      }}
    >
      <Button onClick={() => onApplyFilters()} variant="secondary">
        {buttonApply}
      </Button>
      <div style={{ marginLeft: '1rem' }}>
        <Button onClick={() => onApplyFilters(true)}>{buttonReset}</Button>
      </div>
    </div>
  );
};

ActionButtons.propTypes = {
  onApplyFilters: PropTypes.func.isRequired
};

export default ActionButtons;
